// Link verso le pagine "legacy" di Golia Core (infrazioni e grafico
// vettoriale/attività cronotachigrafo). Condiviso tra le quick action del
// veicolo e degli autisti e la pagina di analisi.
//
// I metodi girano nel contesto del componente, quindi hanno accesso a
// `this.$openGoliaCore` e `this.moment` (wrapper Dater) senza dipendenze extra.

// Finestre temporali imposte dalle pagine legacy di Golia.
const INFRINGEMENTS_WINDOW_DAYS = 56 // le due date non devono superare i 56 giorni
const TACHOGRAPH_WINDOW_DAYS = 57

export default {
    methods: {
        openGoliaInfringements({ driverId = null, vehicleId = null } = {}) {
            const isVehicle = !!vehicleId

            const dataAl = this.moment().format('YYYY-MM-DD')
            const dataDal = this.moment()
                .subtract(INFRINGEMENTS_WINDOW_DAYS, 'days')
                .format('YYYY-MM-DD')

            this.$openGoliaCore({
                get: [],
                post: {
                    btnForm: 'ok',
                    tipoAutisti: 'Tutti',
                    autista: isVehicle ? '0' : String(driverId),
                    tipoCamion: 'Tutti',
                    camion: isVehicle ? String(vehicleId) : '0',
                    dataDal,
                    dataAl,
                    gravita: '0',
                    filiale: '',
                    giornataSolare: 'ok',
                    datiExtra: 'ok',
                    numRecPP: '5',
                    Submit: ''
                },
                page: '/inc/infrazioni/infrList.php'
            })
        },
        openGoliaTachographActivities({
            driverId = null,
            vehicleId = null,
            dataDal = null,
            giorni = null
        } = {}) {
            const isVehicle = !!vehicleId

            // Di default mostra gli ultimi TACHOGRAPH_WINDOW_DAYS giorni; la pagina
            // di analisi passa invece l'intervallo selezionato (dataDal + giorni).
            const days = giorni != null ? giorni : TACHOGRAPH_WINDOW_DAYS
            const from =
                dataDal || this.moment().subtract(days, 'days').format('YYYY-MM-DD')

            this.$openGoliaCore({
                get: [],
                post: {
                    autista: isVehicle ? '' : String(driverId),
                    camion: isVehicle ? String(vehicleId) : '',
                    dataDal: from,
                    giorni: String(days),
                    divWidth: '1519.76',
                    formGrafVett: 'ok',
                    actInOneRow: '0',
                    viewAssenze: '1',
                    viewCountry: '1',
                    viewInfrazioni: '1',
                    viewCommenti: '1',
                    viewAllegati: '1',
                    viewDDD: '0',
                    viewEvents: '0'
                },
                page: '/inc/graficoVettoriale/graficoVett2.php'
            })
        }
    }
}
